/**
 * Task list helpers, shared by the To-Do hub (MyTasksPage) and the Agreement Tasks tab.
 *
 * Sorting moved to the server (P41 phase 2, Pedro 2026-10-15): every column header sorts
 * across pages and the old "Sort by" box (P14), which sorted only the fetched page, is
 * gone. The server keeps the existing rules: deadline, earliest first, by default, and
 * overdue open tasks pinned to the top under every sort.
 */
import type { AgreementTask } from '../api/types';

/** The header sort keys the /agreement-tasks endpoint accepts. */
export type TaskSortKey =
  | 'deadline' | 'urgency' | 'description' | 'related' | 'rm' | 'assignee' | 'status' | 'created';

export function todayLocalISO(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function isOverdue(t: AgreementTask): boolean {
  return t.status === 'OPEN' && t.deadline < todayLocalISO();
}
